import { getCookie } from "../hooks/helpers";

export let banner = `?bannerid=${getCookie("bannerid") || "4900689189"}`;
export let webView = window.webview;
export let webviewEvents = window.webviewEvents;
export let isRegionalDomain = window.isRegionalDomain;
export const adminUrl = process.env.FRONT_ADMIN_DOMAIN;
